import React from 'react';

import { Tooltip } from 'antd';

interface TermTooltipProps {
  /** What the term means. When omitted, the children render unchanged. */
  tooltip?: string;
  children: React.ReactNode;
}

/**
 * A label containing a term users may not know (e.g. RUE), with a dotted
 * underline that explains it on hover (OP-2528). The underline is in the
 * text's own colour, so it reads on light and dark backgrounds.
 */
const TermTooltip: React.FC<TermTooltipProps> = ({ tooltip, children }) =>
  tooltip ? (
    <Tooltip title={tooltip}>
      <span className="cursor-help underline decoration-current decoration-dotted underline-offset-2">
        {children}
      </span>
    </Tooltip>
  ) : (
    <>{children}</>
  );

export default TermTooltip;
